
export const checkMidwaySelect = (list, isSelected) => {
    if (list.some(isSelected)) {
        // either all or midway
        return (
            list.some((pe) => !isSelected(pe)) ? (
                "midway"
            ) : (
                true
            )
        );
    } else {
        return false;
    }
};
